import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DisableByGrade.scss';

const GradeSelector = ({onChangeGradesDisabled, hasSchoolWindowDisabledByGradeOverride, selectedEntity}) => {

  const { t } = useTranslation(['common', 'admin_benchmark_configuration']);

  const initialGrades = [
    { label: t('grade_0'), disabled: false },
    { label: t('grade_1'), disabled: false },
    { label: t('grade_2'), disabled: false },
    { label: t('grade_3'), disabled: false },
    { label: t('grade_4'), disabled: false },
    { label: t('grade_5'), disabled: false },
    { label: t('grade_6'), disabled: false },
  ];

  const [grades, setGrades] = useState(initialGrades);

  useEffect(() => {
    onChangeGradesDisabled(initialGrades.map((grade) => grade.disabled));
  }, []);

  // We do not allow school level to disable by grade yet.
  if(selectedEntity === 'school'){
      return null;
  }

  const handleSelection = (index) => {
    const newGrades = [...grades];
    newGrades[index].disabled = !newGrades[index].disabled;
    setGrades(newGrades);

    const gradesDisabledArray = newGrades.map((grade) => {
      return grade.disabled
    });

    onChangeGradesDisabled(gradesDisabledArray);
  };

  return (
    <div className='disable-by-grade-form'>
      <h1>{t('select_grades', {ns: 'admin_benchmark_configuration'})}</h1>
      {hasSchoolWindowDisabledByGradeOverride && <p className="warning">{t('disable_by_grade_warning', {ns: 'admin_benchmark_configuration'})}</p>}
      <ul>
        {grades.map((grade, index) => (
          <li key={index}>
            <label>
              <input
                type="checkbox"
                checked={!grade.disabled}
                onChange={() => handleSelection(index)}
              />
              {grade.label}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GradeSelector;
